<div class="wa-ai-container">
  <div class="wa-ai-header">
    <div>
      <h2>WhatsApp AI Agent Conversations</h2>
      <p>Option 6 conversations with text, voice notes, transcriptions and Saba audio replies.</p>
    </div>
    <span class="wa-ai-total">{{ totalElements | number }} Sessions</span>
  </div>

  <div class="wa-ai-filters">
    <div class="wa-ai-search">
      <span class="search-icon">⌕</span>
      <input
        type="text"
        [formControl]="searchControl"
        placeholder="Search by phone number..."
        inputmode="numeric"
        (keypress)="onSearchKeyPress($event)"
        (input)="onSearchInput($event)" />
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Range From</mat-label>
      <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="fromDate" name="fromDate" [max]="toDate" readonly />
      <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
      <mat-datepicker #dateFromPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Range To</mat-label>
      <input matInput [matDatepicker]="dateToPicker" [(ngModel)]="toDate" name="toDate" [min]="fromDate" readonly />
      <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
      <mat-datepicker #dateToPicker></mat-datepicker>
    </mat-form-field>

    <div class="wa-ai-actions">
      <button class="primary" (click)="applyFilters()">Apply</button>
      <button class="secondary" (click)="onClear()">Clear</button>
    </div>
  </div>

  <div class="wa-ai-table-wrap">
    <table class="wa-ai-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Phone Number</th>
          <th>Messages</th>
          <th>Audio Turns</th>
          <th>Last Message</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="6" class="empty">Loading AI agent conversations...</td>
        </tr>
        <tr *ngIf="!isLoading && sessions.length === 0">
          <td colspan="6" class="empty">No Option 6 conversations found.</td>
        </tr>
        <tr *ngFor="let session of sessions; trackBy: trackByIndex">
          <td>{{ session.sr }}</td>
          <td>
            <span class="dot"></span>
            {{ session.phoneNumber }}
          </td>
          <td><span class="pill">{{ session.messageCount }}</span></td>
          <td><span class="pill audio">{{ session.audioCount || 0 }}</span></td>
          <td>{{ session.lastMessageTime | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>
            <button class="icon-btn" title="View Conversation" (click)="openConversation(session.phoneNumber)">View</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="wa-ai-pagination">
    <span>Showing {{ totalElements ? (currentPage * pageSize) + 1 : 0 }}–{{ pageEnd }} of {{ totalElements | number }}</span>
    <div>
      <button [disabled]="currentPage === 0" (click)="goToPrev()">Prev</button>
      <span>{{ displayPage }} / {{ totalPages || 1 }}</span>
      <button [disabled]="currentPage >= totalPages - 1" (click)="goToNext()">Next</button>
    </div>
  </div>

  <div class="wa-ai-overlay" *ngIf="showModal">
    <div class="wa-ai-modal">
      <div class="wa-ai-modal-header">
        <div class="wa-icon">AI</div>
        <div>
          <div class="label">WhatsApp AI Agent</div>
          <div class="phone">{{ selectedPhone }}</div>
        </div>
        <span class="count">{{ messages.length }} Messages</span>
        <button class="close" (click)="closeModal()">×</button>
      </div>

      <div class="wa-ai-chat">
        <div *ngIf="isModalLoading" class="modal-empty">Loading conversation...</div>
        <div *ngIf="!isModalLoading && messages.length === 0" class="modal-empty">No conversation history found.</div>

        <div
          *ngFor="let msg of messages; trackBy: trackByIndex"
          class="bubble-row"
          [class.inbound]="msg.direction === 'INBOUND'"
          [class.outbound]="msg.direction === 'OUTBOUND'">
          <div class="avatar">{{ msg.direction === 'INBOUND' ? 'U' : 'Saba' }}</div>
          <div class="bubble">
            <div class="audio-box" *ngIf="hasAudio(msg)">
              <div class="audio-label">{{ msg.direction === 'INBOUND' ? 'Citizen voice note' : 'Saba voice reply' }}</div>
              <audio *ngIf="msg.audioObjectUrl" [src]="msg.audioObjectUrl" controls preload="metadata"></audio>
              <span *ngIf="!msg.audioObjectUrl" class="audio-loading">Preparing audio...</span>
            </div>

            <div class="text" *ngIf="msg.message">{{ msg.message }}</div>

            <div class="meta">
              <span>{{ msg.dateTime | date:'dd/MM HH:mm' }}</span>
              <span class="type">{{ msg.messageType || 'text' }}</span>
              <span class="status" *ngIf="msg.status">{{ msg.status }}</span>
              <span *ngIf="msg.hermesElapsedMs">Hermes {{ msg.hermesElapsedMs }}ms</span>
              <span *ngIf="msg.ttsElapsedMs">TTS {{ msg.ttsElapsedMs }}ms</span>
            </div>

            <div class="error" *ngIf="msg.errorMessage">{{ msg.errorMessage }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
